<template>
  <v-toolbar flat dark color="primary">
    <v-list>
      <v-list-item class="px-0">
        <v-list-item-content>
          <div class="small-logo">S</div>
          <router-link class="big-logo" :to="{ path: homeLink }">
            <v-list-item-title class="title">{{ config ? config.application_name : 'Sesja.pl' }}</v-list-item-title>
            <v-list-item-subtitle>Panel Administracyjny</v-list-item-subtitle>
          </router-link>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-toolbar>
</template>

<script>
  import { mapState } from 'vuex';
  import * as roles from '@/utils/user-roles';

  export default {
    name: 'NavigationHeader',
    data() {
      return {
        homeLink: '',
      };
    },
    computed: {
      ...mapState('config', ['config']),
      ...mapState('auth', ['userRoles', 'isLogged']),
    },
    created() {
      this.setProperHomeLink();
    },
    methods: {
      setProperHomeLink() {
        if (
          this.userRoles.includes(roles.ROLE_ROOT)
        ) {
          this.homeLink = '/streams/control';
        } else if (
          this.userRoles.includes(roles.ROLE_STREAM_MANAGER)
        ) {
          this.homeLink = '/streams/changelog';
        } else if (this.userRoles.includes(roles.ROLE_VOTE_MANAGER)) {
          this.homeLink = '/sessions/list/';
        } else if (this.userRoles.includes(roles.ROLE_VOTE_VIEWER)) {
          this.homeLink = '/vote/hello';
        } else if (
          this.userRoles.includes(roles.ROLE_DOCUMENT_MANAGER) ||
          this.userRoles.includes(roles.ROLE_DOCUMENT_VIEWER)
        ) {
          this.homeLink = '/documents/list/';
        } else if (this.userRoles.includes(roles.ROLE_NOTIFICATION_MANAGER)) {
          this.homeLink = '/users/notifications-list/';
        } else if (this.userRoles.includes(roles.ROLE_USER_MANAGER)) {
          this.homeLink = '/users/list/';
        } else if (this.userRoles.includes(roles.ROLE_GROUP_MANAGER)) {
          this.homeLink = '/users/list/';
        } else if (this.userRoles.includes(roles.ROLE_VOD_MANAGER)) {
          this.homeLink = '/vod/browse-videos';
        } else {
          this.homeLink = '/profile';
        }
      },
    },
  };
</script>

<style lang="scss">
  .small-logo {
    font-size: 20px;
    font-weight: bold;
    left: 5px;
    top: 20px;
    position: absolute;
    opacity: 1;
    transition: opacity 0.2s ease;
  }
  .big-logo {
    opacity: 0;
    transition: opacity 0.2s ease;
    color: white !important;
    text-decoration: none;
  }
  .v-navigation-drawer {
    .small-logo {
      opacity: 0;
    }
    .big-logo {
      opacity: 1;
    }
    &--is-mouseover {
      .small-logo {
        opacity: 0;
      }
      .big-logo {
        opacity: 1;
      }
    }
    &--mini-variant {
      .small-logo {
        opacity: 1;
      }
      .big-logo {
        opacity: 0;
      }
    }
  }
</style>
